import isToday from 'date-fns/isToday';

export function arrayEquals<T>(a: T[], b: T[]) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length != b.length) return false;

    for (let i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false;
    }

    return true;
}

function copyArray(src: any[], includeProp?: (v: any, k: any) => boolean) {
    let dst = [];
    for (let i=0 ; i < src.length ; i++) {
        if (includeProp && !includeProp(src[i], i)) {
            continue;
        }
        dst.push(copy(src[i], null, null, includeProp));
    }
    return dst;
}

function copyObject(src: object, props?: string[], excludeProps?: string[], includeProp?: (v: any, k: any) => boolean) {
    let dst = {};
    for (let k in src) {
        if (src.hasOwnProperty(k) && (!props || props.indexOf(k) != -1) && (!excludeProps || excludeProps.indexOf(k) == -1)) {
            let v = src[k];
            if (includeProp && !includeProp(v, k)) {
                continue;
            }
            if (v) {
                if (Array.isArray(v)) {
                    dst[k] = copyArray(v, includeProp)
                    continue;
                }
                if (typeof v == 'object') {
                    dst[k] = copyObject(v, null, null, includeProp);
                    continue;
                }
            }
            dst[k] = v;
        }
    }
    return dst;
}

export function copy(src: any, props?: string[], excludeProps?: string[], includeProp?: (v: any, k: any) => boolean) {
    if (src) {
        if (Array.isArray(src)) {
            return copyArray(src, includeProp);
        }
        if (typeof src == 'object') {
            return copyObject(<object>src, props, excludeProps, includeProp);
        }
    }
    return src;
}

export function copyWithoutEmptyStrings(src: any, props?: string[], excludeProps?: string[]) {
    return copy(src, props, excludeProps, v => v !== '');
}

export function checkIsToday(year: number, month: number, day: number) {
    return isToday(new Date(year, month-1, day));
}